import gql from 'graphql-tag';

export const ALL_MEMBERS_QUERY = gql`
  query AllMembers($query: String, $sort: MemberV2SortInput) {
    me {
      ... on StaffMember {
        id
        practice {
          id
          memberV2Count
          memberV2s(query: $query, sort: $sort) {
            edges {
              node {
                id
                firstName
                lastName
                subscriptionStatus
                activeSubscription {
                  endDate
                }
                membershipV2 {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
`;
